module.exports = __webpack_public_path__ + "img/student-profile-image.47aca096.png";